'use strict';

var capitalize$1 = require('../../../../_virtual/capitalize.js_commonjs-exports.js');

Object.defineProperty(capitalize$1.__exports, "__esModule", {
  value: true
});
var _default = capitalize$1.__exports.default = capitalize;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (process.env.NODE_ENV !== 'production') {
    if (typeof string !== 'string') {
      throw new Error('Material-UI: capitalize(string) expects a string argument.');
    }
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

module.exports = _default;
